import { useContext } from 'react';
import { AnimatorContext } from "../internal/AnimatorContext/index.js";
const useAnimator = () => {
    return useContext(AnimatorContext);
};
export { useAnimator };
